module.exports = __webpack_public_path__ + "ba6bb6dd1c52557a282eeb0e03bd1f4a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-9.png
// module id = 2988
// module chunks = 0